<template>
    <div>
        <div v-if="statesWithAnOffer.includes(state)">
            <div class="operator_product mb-4" v-for="(offer, index) in currentStateOffers" :key="offer.offer.site_offer_id">
                <h2>{{ productName(offer) }}</h2>
                <p v-html="productDescription(offer)"></p>
                <loading-spinner v-if="loading"></loading-spinner>
                <single-offer
                    :img-placeholder="imgPlaceholder"
                    :offer="offer.offer"
                    :list-location="listLocation"
                    :list-position="(index + 1)"
                    :list-id="'_'"
                    :rank-version="'_'"
                    v-else-if="statesWithAnOffer.includes(state) && !loading"
                    :cta-location="ctaLocation + 'pos=' + (index + 1)"
                    :gtm="gtm + '-LOCATION ' + offer.offer.brand_name + ' pos=' + (index + 1)"
                    v-cloak>
                </single-offer>
            </div>
        </div>
        <div class="d-flex flex-row justify-content-center" v-else>
            <div class="no-offer col-12 col-md-6 p-4 mb-2 justify-content-center rounded-lg d-flex">
                <p class="pl-4">{{ brand.brand }} is not available in {{ state }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import SingleOffer from '../../operator_list/SingleOffer.vue';

export default {
    name: 'brand-list',
    components: {
        'single-offer': SingleOffer,
    },
    props: {
        brand: {
            type: Object,
            required: true,
        },
        ctaText: {
            type: String,
            required: true,
        },
        listLocation: {
            type: String,
            required: false,
            default: '_'
        },
        imgPlaceholder: {
            type: String,
            required: true,
        },
        state: {
            type: String,
            required: true
        },
        ctaLocation: {
            type: String,
            required: true
        },
        gtm: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            listData: [],
            currentStateOffers: [],
            loading: false,
            statesWithAnOffer: [],
        };
    },
    mounted() {
        this.populateOffersFromProducts();
    },
    watch: {
        state() {
            this.updateCurrentStateOffers();
        }
    },
    methods: {
        populateOffersFromProducts() {
            this.brand.products.forEach(product => {
                product.offers.forEach(offer => {
                    if (offer.default_site_offer) {
                        if (!this.statesWithAnOffer.includes(offer.us_states[0].code)) {
                            this.statesWithAnOffer.push(offer.us_states[0].code);
                        }
                        offer.brand_name = this.brand.brand;
                        offer.brand_id = this.brand.id;
                        offer.product_type = product.product_type;
                        offer.exit_link = offer.exit_page.link;
                        offer.brand_product_image = product.brand_product_image_for_brand_list;
                        offer.brand_product_id = product.brand_product_id;
                        this.listData.push({
                            product: product,
                            offer: offer,
                        });
                    }
                });
            });
            this.updateCurrentStateOffers();
        },
        updateCurrentStateOffers(){
            this.currentStateOffers = [];
            this.listData.forEach(item => {
                if (item.offer.us_states[0].code == this.state) {
                    this.currentStateOffers.push(item);
                }
            });
        },
        productName(item) {
            if (item.product.product_type == 'Daily Fantasy') {
                return item.product.brand_name + ' ' + item.product.product_type + ' - ';
            }

            let offer = item.product.offers[0].promo.code ? 'Promo Code' : 'Bonus Offer';

            return (item.product.brand_name + ' ' + item.offer.us_states[0].code + ' ' + item.product.product_type + ' ' + offer);
        },
        productDescription(item) {
            return item.product.offers[0].site_offer_bonus_description;
        },
        productReviewLink() {
            if (typeof this.item.product.review === 'object') {
                return this.item.product.review.link;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
    .no-offer {
        background-color: #ececec;
        img {
            max-width: 100px;
        }
        p {
            font-size: 18px;
            font-weight: bold;
            line-height: 1.2;
        }

    }

</style>